function propagateTrackingParams() {
  const trackingParams = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
    'gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid',
    'tw_source', 'tw_adid', 'tw_campaign', 'tw_kwdid',
    'hsa_acc', 'hsa_cam', 'hsa_grp', 'hsa_ad', 'hsa_src',
    'hsa_tgt', 'hsa_kw', 'hsa_mt', 'hsa_net', 'hsa_ver'
  ];

  const currentParams = new URLSearchParams(window.location.search);

  const paramsToPropagate = new URLSearchParams();
  trackingParams.forEach(param => {
    if (currentParams.has(param) && currentParams.get(param) !== '') {
      paramsToPropagate.set(param, currentParams.get(param));
    }
  });

  if ([...paramsToPropagate].length === 0) return;

  const allowedHostnames = ['app.caffeinearmy.com.br'];

  function injectParams(link) {
    try {
      const url = new URL(link.href, window.location.origin);

      if (url.hostname === window.location.hostname) return;
      if (!allowedHostnames.includes(url.hostname)) return;

      paramsToPropagate.forEach((value, key) => {
        if (!url.searchParams.has(key)) {
          url.searchParams.set(key, value);
        }
      });

      link.href = url.toString();
    } catch (e) {}
  }

  document.querySelectorAll('a[href]').forEach(injectParams);

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'A') injectParams(node);
        node.querySelectorAll?.('a[href]').forEach(injectParams);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

propagateTrackingParams();
